module.exports = __webpack_public_path__ + "Profile_avatar.png?b8c2f78a8a8ba3f37ce2516986196062";


//////////////////
// WEBPACK FOOTER
// ./assets/images/Profile_avatar.png
// module id = 241
// module chunks = 0